const navLinks = ['home', 'calculator', 'quote'];

export default navLinks;
